export const pieChartConfig = {
    options: {
        chart: {
            type: 'pie',
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            title: '',
        },
        yAxis: {
            title: '',
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                animation: false,
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.2f}%',
                },
            },
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{points.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%<br/>',
        },
        series: [
            {
                data: [],
            },
        ],
        reflow: true,
    },
};
